import React from "react";
import "./NoResultsFound.scss";

/**
 * @param {object} props
 * @param {Function} props.handleCancelButton
 * @param {Function} props.handleOnKeyDown
 * @returns {React.JSX.Element}
 */
const NoResultsFound = ({ handleCancelButton, handleOnKeyDown }) => {
    const noResultsFoundMessage =
        "Hmm, we're having trouble finding that employer. You can always double-check with them directly to see if they'll match your gift.";
    return (
        <div className="gift-matching__result--none">
            <p className="gift-matching__result--no-match-text">
                {noResultsFoundMessage}
            </p>
            <button
                type="button"
                className="link -margin-top--15"
                id="gift-matching__clear-text"
                onClick={(e) => handleCancelButton(e)}
                onKeyDown={(e) => handleOnKeyDown(e)}
                tabIndex={0}
                aria-label={`${noResultsFoundMessage} Clear entered text.`}
            >
                <strong>Clear Entered Text</strong>
            </button>
        </div>
    );
};

export default NoResultsFound;
